import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

type SelectProps = {
  variant: "outlined" | "standard" | "filled";
  value: any;
  label: any;
  onChange: (value: any) => void;
  menulist: any;
  menuvalue: any;
  name?: string;
  className?: string;
  fullWidth?: true | false;
  disabled?: false | true;
};

export default function SelectComponent(props: SelectProps) {
  return (
    props.menulist && (
      <Select
        value={props.value}
        label={props.label}
        onChange={(event) => props.onChange(event.target)}
        className={props.className}
        fullWidth={props.fullWidth}
        variant={props.variant}
        id={"select"}
        name={props.name}
        disabled={props.disabled}
      >
        {props.menulist.map((item: any) => (
          <MenuItem key={item.p_id} value={item.p_id}>
            {item[props.menuvalue]}
          </MenuItem>
        ))}
      </Select>
    )
  );
}
